import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
// Install global axios + fetch URL rewriter so /api/* calls always use the
// same origin as the page (fixes 3rd-party-cookie blocking on custom prod
// domains like acf.acfjourneys.online). Must run before any other import
// that issues HTTP calls at module-evaluation time.
import "@/utils/installApiInterceptor";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
